import { render, staticRenderFns } from "./DemographicInfoPopup.vue?vue&type=template&id=31cf3387"
import script from "./DemographicInfoPopup.vue?vue&type=script&lang=js"
export * from "./DemographicInfoPopup.vue?vue&type=script&lang=js"
import style0 from "./DemographicInfoPopup.vue?vue&type=style&index=0&id=31cf3387&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports